import { TeamAccessDTO } from '../team/team-access.dto';

export class AccountListDTO extends TeamAccessDTO {

    id: string;

    name: string;

    description: string;

}
